import * as React from "react";
const SvgDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 1a1 1 0 1 0-2 0v9.586L5.707 7.293a1 1 0 0 0-1.414 1.414l5 5 .006.007a1 1 0 0 0 .698.286h.006c.272 0 .518-.11.697-.286l.008-.008 5-4.999a1 1 0 0 0-1.415-1.414L11 10.586z"
    />
    <path
      fill="currentColor"
      d="M1 12a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1"
    />
  </svg>
);
export default SvgDownload;
